/**
 * Configuração LOCAL do totem (por dispositivo), guardada no localStorage.
 * Hoje guarda o local de impressão do TEF. A tela que edita isso fica atrás de
 * PIN (ver components/config-totem.tsx).
 */
const KEY_LOCAL_IMPRESSAO = 'cardapio-sischef:totem-local-impressao';

export function getLocalImpressaoTotem(): string {
  try {
    return localStorage.getItem(KEY_LOCAL_IMPRESSAO) ?? '';
  } catch {
    return '';
  }
}

export function setLocalImpressaoTotem(valor: string): void {
  try {
    localStorage.setItem(KEY_LOCAL_IMPRESSAO, valor.trim());
  } catch {
    /* localStorage indisponível — ignora */
  }
}
